import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/Main'
import { Button, Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resAddConnection from './resolvers/resAddConnection'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'
import SelectWrapper from 'shared/components/SelectWrapper'
import { togglePasswordInput } from 'utils/passwordUtils'
import { connectionTypes } from 'consts'
import * as Icon from 'react-bootstrap-icons'

const submitRef = React.createRef<HTMLButtonElement>()

const AddConnection: React.FunctionComponent = () => {

  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const [passwordInputType, setPasswordInputType] = useState<string>('password')

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setError,
    control,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resAddConnection,
  })

  useInit({
    getValues,
    id,
    reset,
    setDataLoaded,
    setShowOverlay,
    currentCustomer,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      headerInsert={
        <BackButton url='/connections' text='All Connections' />
      }
      actionInsert={
        <Button
          disabled={!dataLoaded}
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          Save Connection
        </Button>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError,
            id,
            name: 'Connections',
            successNav: '/connections',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Name' name='name' errors={errors}>
          <Form.Control type='text' {...register('name')} />
        </InputWrapper>


        <InputWrapper label='Type' name={'type'} errors={errors}>
          <SelectWrapper
            name={'type'}
            control={control}
            isClearable={false}
            options={connectionTypes}
            optionLabel='name'
            optionValue='id'
            isMulti={false}
            placeholder='Select Connection Type'
          />
        </InputWrapper>

        <InputWrapper label='Host' name='host' errors={errors}>
          <Form.Control type='text' {...register('host')} />
        </InputWrapper>
       
        <InputWrapper label='Database' name='db' errors={errors}>
          <Form.Control type='text' {...register('db')} />
        </InputWrapper>

        <InputWrapper label='Username' name='username' errors={errors}>
          <Form.Control type='text' {...register('username')} />
        </InputWrapper>
        
        {id === undefined && (
        <InputWrapper label='Password' name='password_api' errors={errors}>
          <InputGroup className='mb-3'>
            <Form.Control type={passwordInputType} {...register('password_api')} />

            <OverlayTrigger
              placement='top'
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip>
                  {passwordInputType === 'password' ? 'Show password' : 'Hide password'}
                </Tooltip>
              }
            >
              <Button
                variant='outline-warning'
                onClick={() => setPasswordInputType(togglePasswordInput(passwordInputType))}
              >
                {passwordInputType === 'password' ? <Icon.Unlock /> : <Icon.Lock />}
              </Button>
            </OverlayTrigger>
          </InputGroup>
        </InputWrapper>
        )}

        <Button
          type='submit'
          name='save'
          ref={submitRef}
          className='d-none'
        ></Button>
      </Form>
    </Layout>
  )
}

export default AddConnection
